import dayjs from 'dayjs';
import { Option } from '@core/models';

export const getMonthOptionList = (locale: string, startDate?: string): Option[] => {
  const count = startDate
    ? Math.min(6, dayjs().diff(dayjs(startDate).startOf('month'), 'month') + 1)
    : 6;

  return Array(count)
    .fill(null)
    .map((_, i) => ({
      label: dayjs().locale(locale).subtract(i, 'month').format('MMMM YYYY'),
      id: i.toString(),
    }));
};
